import React from "react";
import { string } from "prop-types";

const LinkedInIcon = ({ className }) => (
  <svg
    className={className}
    fill="none"
    height="24"
    width="26"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.908 7.798V24H.322V7.798h5.586Zm.355-5.002A2.534 2.534 0 0 1 5.4 4.79c-.576.534-1.338.801-2.285.801H3.08c-.926 0-1.67-.267-2.235-.8C.282 4.255 0 3.59 0 2.795 0 1.989.288 1.324.863.8 1.45.267 2.212 0 3.148 0 4.085 0 4.835.267 5.4.801c.564.523.852 1.188.863 1.995ZM26 14.714V24h-5.569v-8.665c0-1.144-.231-2.038-.694-2.681-.451-.654-1.162-.981-2.133-.981-.71 0-1.309.19-1.794.572-.474.37-.83.834-1.067 1.39-.124.327-.186.768-.186 1.324V24H8.988c.023-4.349.034-7.875.034-10.578 0-2.703-.006-4.316-.017-4.839l-.017-.785h5.57v2.355h-.035a7.14 7.14 0 0 1 .694-.916 7.36 7.36 0 0 1 .948-.85c.407-.305.898-.54 1.473-.703a6.817 6.817 0 0 1 1.947-.262c1.93 0 3.481.622 4.655 1.864 1.173 1.232 1.76 3.041 1.76 5.428Z"
      fill="#1876DB"
    />
  </svg>
);

LinkedInIcon.propTypes = {
  className: string
};

LinkedInIcon.defaultProps = {
  className: ""
};

export default LinkedInIcon;
